import { Component } from '@angular/core';
import { MainService } from 'app/resources/services/main.service';

@Component({
  selector: 'app-voucher-sucesso',
  templateUrl: './voucher-sucesso.component.html'
})
export class VoucherSucessoComponent {

  constructor(public mainService: MainService) { }

}



// WEBPACK FOOTER //
// ./src/app/voucher/voucher-sucesso/voucher-sucesso.component.ts